<template>
  <div>
    <v-layout column v-if="isRouteAuthorized">
      <v-flex v-if="showHeaderCard">
        <!-- TODO: Used skeleton while loading for the first time -->
        <Header :theme="getGeneralState('theme_dark')" :date="active.Date" />
      </v-flex>
      <v-flex>
        <router-view
          @filter:config="filterConfigHandler"
          @initial:active_filter="activeFilterHandler"
          @callback:onIntervalChange="onIntervalChange"
          @max:date="maxDateHandler"
          :changesFromFilter="active"
        />
      </v-flex>
    </v-layout>
    <NoDevice
      message="Sorry!! You do not have access to this feature."
      v-else
    ></NoDevice>
    <div
      v-if="showFilter"
      id="mySidenav"
      :class="{
        'open-sidenav': open,
        originalIconColor: !isFilterDisabled,
        disabled: isFilterDisabled,
      }"
      @click="slideFilterHandler"
    >
      <img class="icon" src="@/assets/filter2.svg" alt="filter" />
    </div>
    <FilterModule
      v-if="!isFilterDisabled"
      :filterProps="filter"
      :active="active"
      :maxDate="maxDate"
      :open="open"
      :intervalChangeCallback="intervalChangeCallback"
      @change:state="
        (value) => {
          open = value;
        }
      "
      @changeFilterOption="changeFilterOption"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FilterModule from "@/components/Filter/FilterModule";
import _ from "lodash";
const Header = () => import("@/components/dashboard-inverter/Header");
const NoDevice = () => import("@/components/utility/NoDevice.vue");

export default {
  components: {
    FilterModule,
    Header,
    NoDevice,
  },
  data() {
    return {
      open: false,
      maxDate: "",
      modifiedDashboardName: "",
      active: {},
      filter: [],
      intervalChangeCallback: function() {
        return {
          dateRangeAllowed: 31,
          minimumDateAllowed: ""
        }
      }
    };
  },
  computed: {
    ...mapGetters([
      "getDashboardList",
      "getGeneralState",
      "getShowHeaderCards",
      "showDisabledFilter",
    ]),
    showHeaderCard() {
      return this.getShowHeaderCards(this.$route.name);
    },
    showFilter() {
      return !this.showDisabledFilter(this.$route.name);
    },
    isRouteAuthorized() {
      return this.getDashboardList.some(
        (item) => item.path === this.$route.path
      );
    },
    isFilterDisabled() {
      return _.isEmpty(this.active);
    },
  },
  methods: {
    activeFilterHandler(val) {
      this.active = val;
    },
    filterConfigHandler(val) {
      this.filter = val;
    },
    maxDateHandler(val) {
      this.maxDate = val;
    },
    slideFilterHandler() {
      if (!this.isFilterDisabled) {
        this.open = true;
      }
    },
    changeFilterOption(value) {
      this.active = value
    },
    onIntervalChange(func) {
      this.intervalChangeCallback = func;
    }
  },
};
</script>

<style scoped>
.dashboard-container {
  height: 800px;
  overflow-y: scroll;
  overflow-x: hidden;
}

#mySidenav {
  top: 55px;
  position: fixed;
  right: -12px;
  transition: 0.2s ease-out;
  width: 47px;
  text-decoration: none;
  font-size: 20px;
  color: white;
  border-radius: 5px;
  z-index: 11;
}

.originalIconColor {
  background-color: #fbbc05;
}

.originalIconColor:hover {
  cursor: pointer;
}

#mySidenav .icon:hover {
  right: 0;
  transform: scale(1.2);
}

.open-sidenav {
  right: 390px !important;
}

.icon {
  height: 16px;
  width: 24px;
  margin-top: 8px;
  margin-left: 4px;
}

.disabled {
  background-color: #ffe492;
}

.disabled:hover {
  cursor: not-allowed;
}

@media (max-width: 510px) {
  .open-sidenav {
    right: 290px !important;
  }
}
</style>
